import type { ReactNode } from "react";

import { Card, CardContent } from "../ui/card";

type ScreenShellProps = {
  title: string;
  subtitle: string;
  badge?: string;
  children?: ReactNode;
  unframed?: boolean;
};

export function ScreenShell({ title, subtitle, badge, children, unframed = false }: ScreenShellProps) {
  return (
    <section className="space-y-5">
      <div>
        {badge ? (
          <div className="mb-2 text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-500">
            {badge}
          </div>
        ) : null}
        <h1 className="text-2xl font-semibold tracking-normal text-slate-950">{title}</h1>
        <p className="mt-1 max-w-3xl text-sm text-slate-600">{subtitle}</p>
      </div>
      {unframed ? (
        children ?? (
          <div className="flex h-[300px] items-center justify-center rounded-lg border border-dashed border-slate-200 bg-slate-50 text-sm text-slate-500">
            Screen content staged for the next dashboard PR.
          </div>
        )
      ) : (
        <Card>
          <CardContent className="min-h-[360px]">
            {children ?? (
              <div className="flex h-[300px] items-center justify-center rounded-lg border border-dashed border-slate-200 bg-slate-50 text-sm text-slate-500">
                Screen content staged for the next dashboard PR.
              </div>
            )}
          </CardContent>
        </Card>
      )}
    </section>
  );
}
